import { colors } from "../theme";

interface CustomerPathsProps {
  isDark: boolean;
  onOpenWaitlist: (presets?: {
    interest?: string[];
    betaTester?: boolean;
    contactMe?: boolean;
  }) => void;
}

export function CustomerPaths({ isDark, onOpenWaitlist }: CustomerPathsProps) {
  const cloudFeatures = [
    "S3-compatible API",
    "End-to-end encryption, always",
    "Pricing decreases with data age",
    "Apps for indexing & contextual search",
  ];

  const coloFeatures = [
    "Full sovereignty—your data never leaves your site",
    "75% power reduction vs traditional storage",
    "Lease model, skip hardware refresh pain",
    "Reclaim cooling budget for hungry compute",
  ];

  return (
    <section className="py-32 px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight mb-6">
            Two ways to work with us
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div
            className="p-10 rounded-2xl transition-colors duration-[2000ms]"
            style={{
              backgroundColor: isDark ? `${colors.cyan}10` : `${colors.blue}08`,
              border: `1px solid ${isDark ? `${colors.cyan}30` : `${colors.blue}20`}`,
            }}
          >
            <h3
              className="text-2xl font-semibold mb-4"
              style={{ color: isDark ? colors.cyan : colors.blue }}
            >
              Cloud Storage
            </h3>
            <p
              className="mb-6"
              style={{ color: isDark ? colors.base01 : colors.base1 }}
            >
              Just need archival storage that makes sense? Use Idle Grove as a
              service. Upload your data, let it age gracefully, pay less over
              time.
            </p>
            <ul className="space-y-3 mb-8">
              {cloudFeatures.map((item, i) => (
                <li
                  key={i}
                  className="flex items-center gap-2 text-sm"
                  style={{ color: isDark ? colors.base0 : colors.base00 }}
                >
                  <span style={{ color: isDark ? colors.cyan : colors.blue }}>
                    ✓
                  </span>{" "}
                  {item}
                </li>
              ))}
            </ul>
            <button
              onClick={() => onOpenWaitlist({ interest: ["Cloud Storage"] })}
              className="px-6 py-3 rounded-full font-medium transition-all duration-300 hover:scale-105"
              style={{
                backgroundColor: isDark ? colors.cyan : colors.blue,
                color: isDark ? colors.base03 : colors.base3,
              }}
            >
              Join the waitlist
            </button>
          </div>

          <div
            className="p-10 rounded-2xl transition-colors duration-[2000ms]"
            style={{
              backgroundColor: isDark
                ? `${colors.magenta}10`
                : `${colors.magenta}08`,
              border: `1px solid ${colors.magenta}30`,
            }}
          >
            <h3
              className="text-2xl font-semibold mb-4"
              style={{ color: colors.magenta }}
            >
              Colo & On-Prem
            </h3>
            <p
              className="mb-6"
              style={{ color: isDark ? colors.base01 : colors.base1 }}
            >
              Can't move to cloud due to secrecy or regulation? We get it. Get
              cloud-like simplicity on your own infrastructure. Skip the painful
              hardware refresh cycle. Free up power and cooling for AI and HPC
              that actually need it.
            </p>
            <ul className="space-y-3 mb-8">
              {coloFeatures.map((item, i) => (
                <li
                  key={i}
                  className="flex items-center gap-2 text-sm"
                  style={{ color: isDark ? colors.base0 : colors.base00 }}
                >
                  <span style={{ color: colors.magenta }}>✓</span> {item}
                </li>
              ))}
            </ul>
            <button
              onClick={() =>
                onOpenWaitlist({
                  interest: ["Colo / On-Prem"],
                  contactMe: true,
                })
              }
              className="px-6 py-3 rounded-full font-medium transition-all duration-300 hover:scale-105"
              style={{
                backgroundColor: colors.magenta,
                color: colors.base3,
              }}
            >
              Talk to us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
